import axios from "../api";

// CREATE DOCUMENT TYPE
export const createDocumentTypeAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/kyc/document-types/`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// LIST DOCUMENT TYPES
export const listDocumentTypesAction = (
  page,
  limit,
  search = "",
  provider = "",
  provider_code = "",
  status = ""
) => {
  let apiUrl = `/api/kyc/document-types?page=${page}&limit=${limit}`;

  if (search) {
    apiUrl += `&search=${search}`;
  }

  if (provider) {
    apiUrl += `&provider=${provider}`;
  }

  if (provider_code) {
    apiUrl += `&provider_code=${provider_code}`;
  }

  if (status) {
    apiUrl += `&status=${status}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// GET DOCUMENT TYPE BY ID
export const getDocumentTypeByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/kyc/document-types/${id}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// UPDATE DOCUMENT TYPE
export const updateDocumentTypeAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/kyc/document-types/${id}`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// DELETE DOCUMENT TYPE (soft delete)
export const deleteDocumentTypeAction = async (id, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/kyc/document-types/${id}`, {
        data: payload,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateDocumentTypeStatusAction = async (
  id,
  payload
) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/kyc/document-types/${id}/status`, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};